import type { Context } from "@/common/types/router"
import route from "@/apps/recruiter/router/route"
import type { UserType } from "@/common/types/user"

const requireRoot = () => {
    return async ({ to, next, nextMiddleware, useUser }: Context) => {
        if (to.name !== route.root.name) {
            return nextMiddleware()
        }

        const type = useUser().getUser().type as UserType

        switch (type) {
            case "personnel_officer":
                return next({ name: route.testings.name })
            default:
                return next({ name: route.vacancies.name })
        }
    }
}

export default requireRoot
